import React from 'react';
import CardImageHolder from '../../CardImageHolder';
import { linkify } from '../../../utils/urlUtil';

const CardView = ({ card, device }) => {
  const { title, medium, contents, button, viewType } = card;
  const isPC = device.getIn(['os', 'name']) !== 'Android' && device.getIn(['os', 'name']) !== 'iOS';

  const isVerticalCard = viewType === 'vertical';
  return (
    <div className={button.isEmpty() ? "card_default card_view" : "card_default card_view card_btn"}>
      <div className="inner_card">
        <div className="wrap_thumb">
          <CardImageHolder image={medium} 
            isVertical={isVerticalCard}
          />
          {!button.isEmpty() ?
            (<a href={button.get('linkType') === "phone" ? (isPC ? null : `tel:${button.get('linkTo')}`)
                : button.get('linkTo')}
                target={button.get('linkType') === "phone" ? '_self' : '_blank'}
              >
              <button type="button" className="btn_tel"
                style={{ position: 'static' }}
                onClick={() => isPC && button.get('linkType') === "phone" && alert(`전화번호는 ${button.get('linkTo')} 입니다.`)}
              >
                <span className="inner_txt">{button.get('title')}</span>
              </button>
            </a>) : null}
        </div>
        <div className="info_cont">
          <strong className="tit_card">{title}</strong>
          {!contents.isEmpty() ?
            (<div className="desc_card">
              {linkify(contents)}
            </div>) : null}
        </div>
      </div>
    </div>
)};


export default CardView;



// WEBPACK FOOTER //
// ./src/components/PostBox/media/CardView.js